<template>

	<div id="recipe" v-cloak itemscope itemtype="http://schema.org/Recipe">

		<section class="full-width no-y-padding" id="hero">

			<div v-bind:class="container_class">

				<div class="row">

					<div class="col-12">

						<img class="nopin" v-if="show_image && recipe.recipe_post_top_image" itemprop="image" v-bind:src="recipe.recipe_post_top_image" v-bind:alt="recipe.page_title">
						<div v-if="show_back" class="back" onclick="window.history.back();"><i class="fas fa-arrow-left"></i></div>

						<FavouriteWidget v-if="logged_in" :logged_in="logged_in" v-bind:post.sync="recipe"></FavouriteWidget>
						<PlannerWidget v-if="logged_in" :logged_in="logged_in"></PlannerWidget>

					</div>

				</div>

			</div>

		</section>

		<section class="full-width" id="recipe-intro">

			<div v-bind:class="container_class">

				<div class="row">

					<div class="col-12">

						<!-- <div itemprop="name">Title: {{recipe.recipe_post_top_title}}</div> -->
						<!-- <div>Main title: {{recipe.recipe_post_main_title}}</div> -->
						<h1 itemprop="name">{{recipe.page_title}}</h1>

					</div>

					<div class="col-12">

						<div id="recipe-icons" v-if="icons.length">

							<img v-for="(icon, index) in icons" v-bind:key="index" v-bind:src="icon" alt>

						</div>

						<div class="key-info">

							<div class="timing-wrapper">

								<div v-if="recipe.recipe_post_top_cook_time">Cook
									<meta itemprop="cookTime"> {{recipe.recipe_post_top_cook_time}}</div>
								<div v-if="recipe.recipe_post_top_prep_time">Prep
									<meta itemprop="prepTime"> {{recipe.recipe_post_top_prep_time}}</div>

							</div>

							<div class="people-input-wrapper">

								<div class="label">Serves</div>

								<div class="people-button vue-btn" v-on:click="decrementPeople"><i class="fas fa-caret-left"></i></div>
								<input id="people" readonly v-model.number="people">
								<div class="people-button vue-btn" v-on:click="people++;"><i class="fas fa-caret-right"></i></div>

							</div>


						</div>

						<div class="button-wrapper">

							<button class="core-btn" id="whisk-add-to-basket"><i class="far fa-shopping-cart"></i>Add to shopping list</button>
							<button v-if="enable_goals" class="core-btn" id="mark-goal-complete" v-bind:class="{  'goal-complete' : marked_as_complete, 'thinking' : goal_thinking }" v-bind:disabled="marked_as_complete"  @click="mark_recipe_goal_complete"><i class="far fa-check-square"></i> {{mark_goal_complete_button_text}}</button>
							<button id="print" v-on:click="print" class="core-btn core-btn-secondary"><i class="far fa-print"></i>Print</button>

						</div>

					</div>

				</div>

			</div>

		</section>

		<section class="full-width no-padding-top" id="main">

			<div v-bind:class="container_class">

				<div class="row" v-if="(recipe.recipe_post_main_ingredients && recipe.recipe_post_main_ingredients.length) || (recipe.recipe_ingredients_v2 && recipe.recipe_ingredients_v2.length)">

					<div class="col-12 col-md-6" v-if="(recipe.recipe_post_main_ingredients && recipe.recipe_post_main_ingredients.length) && !recipe.recipe_ingredients_v2">

						<h3>Ingredients</h3>

						<ul>

							<li itemprop="recipeIngredient" v-for="(item, index) in recipe.recipe_post_main_ingredients" v-bind:key="index">{{item.content}}</li>

						</ul>

					</div>

					<div class="col-12 col-md-6" v-if="recipe.recipe_ingredients_v2 && recipe.recipe_ingredients_v2.length">

						<h3>Ingredients</h3>

						<!-- <div class="inline-fields unit-switch">
                            <input type="checkbox" v-model="metric">
                            <label>Metric units</label>
                        </div> -->

						<ul>

							<li itemprop="recipeIngredient" v-for="(item, index) in recipe.recipe_ingredients_v2" v-bind:key="index">{{get_amount(item.amount, item.unit.label, people, serves)['amount']}} {{get_amount(item.amount, item.unit.label, people, serves)['unit']}} {{item.ingredient}}</li>

						</ul>


					</div>

					<div class="col-12 col-md-6" itemprop="recipeInstructions">

						<h3>Method</h3>

						<ol>

							<li v-for="(item, index) in recipe.recipe_post_instructions" v-bind:key="index">{{item.content}}</li>

						</ol>

					</div>

				</div>

				<div class="row" id="notes" v-if="logged_in">

					<div class="col-12">

						<h3>Notes</h3>

						<div v-html="recipe.recipe_post_main_text"></div>
						<div v-html="recipe.recipe_post_notice"></div>

					</div>

				</div>

				<div class="row">

					<div class="col-12">

						<div id="user-notes">

							<h3>Your notes</h3>

							<textarea id="user-note" v-model="user_note"></textarea>
							<div class="core-btn vue-btn" @click="save_note"><i class="far fa-save"></i></div>
							<div class="core-btn vue-btn" @click="delete_note"><i class="far fa-trash-alt"></i></div>

						</div>

					</div>

				</div>

			</div>

		</section>

	</div>

</template>
<script>
	module.exports = {

		name: 'Recipe',

		data() {

			return {

				recipe: pageData.recipe,
				container_class: coreVariables.containerClass,
				serves: coreHelpers.getNested(pageData, 'recipe', 'recipe_post_top_serves'),
				people: coreHelpers.getNested(pageData, 'recipe', 'recipe_post_top_serves'), //set default to serves quantity
				metric: coreHelpers.getNested(pageData, 'preferences', 'units') ? (pageData.preferences.units === 'metric' ? true : false) : true,
				id: pageData.id,
				logged_in: false,
				types: coreHelpers.getNested(pageData, 'types') ? pageData.types : [],
				dietary_preferences: coreHelpers.getNested(pageData, 'dietary_preferences') ? pageData.dietary_preferences : [],
				user_note: '',

				//goals
				enable_goals: coreHelpers.getNested(pageData, 'goals', 'set'),
				marked_as_complete: false,
				goal_thinking: false,
				mark_goal_complete_button_text: 'I made this recipe',

			}

		},

		computed: {

			icons() {

				let urls = [];

				this.types.forEach((type) => {

					switch (type.slug) {
						case 'dairy-free':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/df.png');
							break;
						case 'gluten-free':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/gf.png');
							break;
						case 'nut-free':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/nf.png');
							break;
						case 'pescetarian':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/pesc.png');
							break;
						case 'vegetarian':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/veg.png');
							break;

						default:
							break;
					}

				});

				this.dietary_preferences.forEach((type) => {

					switch (type.slug) {
						case 'pescetarian':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/pesc.png');
							break;
						case 'vegetarian':
							urls.push(window.coreVariables.stylesheetUri + '/images/icons/recipe/veg.png');
							break;

						default:
							break;
					}

				});

				return urls;

			}

		},

		props: {

			show_back: {

				default: true,

			},
			show_fav: {

				default: true,

			},
			show_image: {

				default: true,

			},
			scroll_into_view: {

				default: false,
			}

		},

		watch: {

			people: function() {

				window.pageData.whisk_scale = this.people / this.serves;

				this.add_whisk_listener();

			},

			marked_as_complete() {

				this.mark_goal_complete_button_text = 'Complete!';

			}

		},

		mounted() {

			this.get_user_id();
			this.get_notes();

			window.pageData.whisk_scale = 1;

			this.add_whisk_listener();

			if (this.scroll_into_view) {

				document.querySelector('#recipe').scrollIntoView({
					behavior: 'smooth'
				});

			}

			setTimeout(() => {

				if(!this.marked_as_complete) {

					window.vueMessages.addMessage('Click here to mark this recipe as complete', false, "window.vueRecipe.$refs['recipe'].mark_recipe_goal_complete")

				}


			 }, 600000, this);
		},

		methods: {

			add_whisk_listener() {

				console.log('LC: adding whisk click listener')

				whisk.queue.push(function() {

					window.whisk.listeners.addClickListener('whisk-add-to-basket', 'shoppingList.addRecipeToList', {

						scale: window.pageData.whisk_scale,
						recipeUrl: window.pageData.recipe.permalink,

					});

				});

			},

			decrementPeople() {

				if (this.people > 1) {

					this.people--;

				}

			},

			get_amount(amount, unit, people, serves) {

				let newAmount = (people / serves * amount);

				switch (unit) {

					case 'tsp':

						if (newAmount > 3) {

							unit = 'tbsp';
							newAmount = newAmount / 3;

						}

						break;

					case 'tbsp':

						/* if (newAmount > 8) {

						    unit = 'cup';
						    newAmount = (newAmount / 8) * 0.5;
						    break;

						} */
						if (newAmount < 1) {

							unit = 'tsp';
							newAmount = newAmount * 3;
							break;

						}

						break;

					case 'cup':

						if (newAmount < 0.25) {

							unit = 'tbsp';
							newAmount = newAmount * 16;

						}

						break

						/* case 'g':

						    if (newAmount > 1000) {

						        unit = 'kg';
						        newAmount = newAmount / 1000;

						    }

						    break;

						case 'kg':

						    if (newAmount < 0.1) {

						        unit = 'g';
						        newAmount = newAmount * 1000;

						    }

						    break;

						case 'ml':

						    if (newAmount > 1000) {

						        unit = 'l';
						        newAmount = newAmount / 1000;

						    }

						    break;

						case 'l':

						    if (newAmount < 0.1) {

						        unit = 'ml';
						        newAmount = newAmount * 1000;

						    }

						    break; */

				}

				//decimal place calculations
				let decimalPlaces;

				switch (unit) {

					case 'l':
					case 'kg':
						decimalPlaces = 2;
						break;
					case 'tsp':
					case 'tbsp':
					case 'ml':
					case 'g':
						decimalPlaces = 1;
						break;
					default:
						decimalPlaces = 1;

				}

				//unit conversions
				if (!this.metric) {

					switch (unit) {
						case 'kg':
							newAmount = newAmount * 2.205;
							unit = 'lb';
							break;
						case 'g':
							newAmount = newAmount / 28.35;
							unit = 'oz';
							break;
						case 'ml':
							newAmount = newAmount / 29.574
							unit = 'fl oz';
							break;
						case 'l':
							newAmount = newAmount * 33.814
							unit = 'fl oz';
							break;
						case 'cm':
							newAmount = newAmount / 2.54
							unit = 'inches';
							break;

					}

				}

				let rounded = newAmount.toFixed(2);

				switch (rounded.split('.')[1]) {
					case '75':
						newAmount = rounded.split('.')[0] + ' 3/4';
						break;
					case '66':
					case '60':
						newAmount = rounded.split('.')[0] + ' 2/3';
						break;
					case '50':
						newAmount = rounded.split('.')[0] + ' 1/2';
						break;
					case '33':
					case '30':
						newAmount = rounded.split('.')[0] + ' 1/3';
						break;
					case '25':
						newAmount = rounded.split('.')[0] + ' 1/4';
						break;
				}

				if (typeof newAmount === 'string') {

					return {

						amount: newAmount.replace(/^0 /g, ''),
						unit: unit,

					}

				}

				rounded = newAmount.toFixed(decimalPlaces);

				let final = rounded.replace('.00', '').replace('.0', '');

				return {

					amount: final,
					unit: unit,

				}

			},

			print() {

				window.print();

			},

			save_note() {

				window.coreHelpers.ajax.call(this, 'POST', 'lc_update_note', {

					'note': this.user_note,
					'post_id': this.id,

				}, function(res) {

					this.thinking = false;
					coreVariables.triggerModal('Success', 'Your note has been saved');

				}, function(res) {

					this.thinking = false;
					coreVariables.triggerModal('Slight issue', 'We could not save your note, please try again later');

				});

			},

			delete_note() {

				window.coreHelpers.ajax.call(this, 'POST', 'lc_delete_notes', {

					'note': this.user_note,
					'post_id': this.id,

				}, function(res) {

					this.thinking = false;
					this.user_note = '';
					coreVariables.triggerModal('Success', 'Your note has been deleted');

				}, function(res) {

					this.thinking = false;
					coreVariables.triggerModal('Slight issue', 'We could not delete your note, please try again later');

				});

			},

			get_notes() {

				window.coreHelpers.ajax.call(this, 'POST', 'lc_get_notes', {

					'post_id': this.id,

				}, function(res) {

					this.thinking = false;
					this.user_note = coreHelpers.getNested(res, 'data') ? JSON.parse(coreHelpers.getNested(res, 'data')).text : '';

				}, function() {

					this.thinking = false;

				});

			},

			get_user_id() {

				window.coreHelpers.ajax.call(this, 'GET', 'lc_get_user_id', false, function(res) {

					this.logged_in = res.data ? true: false;

				}, function(res) {

					this.logged_in = false;

				});

			},

			mark_recipe_goal_complete() {

				this.goal_thinking = true;

				window.coreHelpers.ajax.call(this, 'POST', 'lc_update_goal_tally', {

					'date': window.DateTime.local().toFormat('ddMMyyyy'),
					'type': 'recipe',

				}, function(res) {

					if (res.success) {

						this.marked_as_complete = true;
						console.log('LC: goal updated', res);

						//update goal progress if on the btb page
						if(coreHelpers.getNested(window, 'vueBTBHome', '$refs', 'goal-progress')) {

							const updatedTally = coreHelpers.getNested(res, 'data', 'updated_data', ':goal_tally');
							window.vueBTBHome.$refs['goal-progress']['goal_tally'] = updatedTally;

						}

						if(!coreHelpers.getNested(pageData, 'goals', 'disable')) {

							if(coreHelpers.getNested(res, 'data', 'params', 'recipe_target_exceeded')) {

								window.vueMessages.addMessage('You’re kicking goals! How delicious... ', false, false, 'goal-achieved');

								window.lcGA('Goals', 'Complete', 'Recipe goal exceeded', coreVariables.userId);

							}
							else if(coreHelpers.getNested(res, 'data', 'params', 'recipe_goal_complete')) {

								window.vueMessages.addMessage('You’re kicking goals! How delicious... ', false, false, 'goal-achieved');

								window.lcGA('Goals', 'Complete', 'Recipe goal', coreVariables.userId);

							}
							else if(coreHelpers.getNested(res, 'data', 'params', 'recipe_streak')) {

								window.vueMessages.addMessage('You’re on a streak! Keep up the great work.', false, false, 'streak');

								window.lcGA('Goals', 'In progress', 'Recipe streak', coreVariables.userId);

							}
							else {

								window.vueMessages.addMessage('Well done! You’re making magic in the kitchen.', false, false, 'cooking');

								window.lcGA('Goals', 'In progress', 'Recipe', coreVariables.userId);

							}

						}

					} else {

						console.log('LC: mark_recipe_goal_complete error');

					}

					this.goal_thinking = false;

				}, function(res) {

					console.log('LC: mark_recipe_goal_complete error');
					this.goal_thinking = false;

				});

			}

		}

	}
</script>